import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const LINKS = [
  { to: "/enterprise-2", label: "Home", key: "home" },
  { to: "/enterprise-2/solution", label: "What We Build", key: "solution" },
  { to: "/enterprise-2/about", label: "About", key: "about" },
  { to: "/enterprise-2/research", label: "Research", key: "research" },
  { to: "/enterprise-2/contact", label: "Contact", key: "contact" },
];

// Floating pill navigation (Adaption Labs reference): logo pill · links pill · login pill · outlined CTA pill.
const DEFAULT_CROSS = { to: "/machines-2", label: "For Machines", testId: "e2-nav-machines" };

export function Nav({ active, links = LINKS, cross = DEFAULT_CROSS, brandTo = "/gateway-2" }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`e2-nav${scrolled ? " is-scrolled" : ""}${open ? " is-open" : ""}`} data-testid="e2-nav">
      <div className="e2-nav-inner">
        <Link to={brandTo} className="e2-nav-pill e2-nav-brand" data-testid="e2-nav-brand" aria-label="Crowther — Gateway">
          <img src="/brand/gateway/crowther-icon-white.webp" alt="Crowther" className="e2-nav-logo" />
        </Link>

        <div className={`e2-nav-pill e2-nav-links${open ? " open" : ""}`} data-testid="e2-nav-links">
          {links.map((l) => (
            <Link
              key={l.key}
              to={l.to}
              aria-current={active === l.key ? "page" : undefined}
              data-testid={`e2-nav-${l.key}`}
              onClick={() => setOpen(false)}
            >
              {l.label}
            </Link>
          ))}
          <Link to={cross.to} className="e2-nav-cross" data-testid={cross.testId} onClick={() => setOpen(false)}>
            {cross.label}
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path d="M7 17L17 7M9 7h8v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>

        <div className="e2-nav-cta">
          <Link to="/login-2" className="e2-nav-pill e2-nav-login" data-testid="e2-nav-login">Login</Link>
          <Link to="/plan-2" className={`e2-nav-pill e2-nav-roadmap${active === "roadmap" ? " is-active" : ""}`} aria-current={active === "roadmap" ? "page" : undefined} data-testid="e2-nav-cta">
            Get Your AI Roadmap
          </Link>
          <button
            type="button"
            className="e2-nav-pill e2-nav-menu-btn"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
            aria-expanded={open}
            data-testid="e2-nav-menu"
          >
            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" aria-hidden>
              <path d="M0 1h18M0 6h18M0 11h18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </div>
    </nav>
  );
}
